module.exports = require("./id-ID.js");